import fr from 'facet-rest';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import Switch from 'Components/UI/Switch';
import moment from 'moment';
import { fullDateISO } from 'Consts/DateFormats';
import PicklistRadioGroup from 'Components/UI/Radio/PicklistRadioGroup';
import SelectField from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';

const fieldsToHide = [
  'moduleName',
  'primaryText',
  'secondaryText',
  'title',
];

const AllocationTableCellFormOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride(fieldsToHide, { hidden: true })
  .typeOverride('date', {
    _customProps: {
      openTo: 'year',
      inputProps: {
        inputMode: 'decimal',
      },
    },
    _component: () => DateField,
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment.utc(v).format(fullDateISO);
    },
  })
  .typeOverride('number', {
    _customProps: {
      inputProps: {
        inputMode: 'decimal',
      },
    },
  })
  .typeOverride('picklist', { _component: () => PicklistRadioGroup })
  .typeOverride('multipicklist', { _component: () => SelectField })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  })
  .nameOverride('shouldGrowWithInflation', {
    _component: () => Switch,
  })
  .nameOverride('when', {
    _customProps: {
      label: '',
    },
  })
  .nameOverride('overrideStartDate', {
    _component: () => DateField,
    _customProps: {
      views: ['year', 'month'],
      placeholder: 'MM/YYYY',
      format: 'MM/YYYY',
      allowKeyboardControl: false,
    },
  })
  .nameOverride('overrideEndDate', {
    _component: () => DateField,
    _customProps: {
      views: ['year', 'month'],
      placeholder: 'MM/YYYY',
      format: 'MM/YYYY',
      allowKeyboardControl: false,
    },
  });

export default AllocationTableCellFormOverride;
